import { StyleSheet, Platform } from 'react-native';
import { AdminColors } from '../../../../../Admin/constants/adminColors';
import FontFamily from '../../../../../../constants/fonts';

const isWeb = Platform.OS === 'web';

const styles = StyleSheet.create({
  // ── "0/2 signed" badge — amber when pending, green when complete ───────
  signedBadge: {
    borderRadius: 20,
    paddingHorizontal: 10,
    paddingVertical: 3,
  },
  signedBadgePending: {
    backgroundColor: '#FEF3C7',   // amber-50
  },
  signedBadgeComplete: {
    backgroundColor: AdminColors.green75,
  },
  signedBadgeText: {
    fontFamily: FontFamily.medium,
    fontSize: 12,
  },
  signedBadgeTextPending:  { color: '#D97706' },
  signedBadgeTextComplete: { color: AdminColors.green600 },

  // ── Body ───────────────────────────────────────────────────
  body: {
    gap: 16,
  },
  introCopy: {
    fontFamily: FontFamily.regular,
    fontSize: isWeb ? 13 : 12,
    color: AdminColors.textSecondary,
    lineHeight: 18,
  },

  // ── Signature card stack — matches HTML `.people-signature-stack` ─────
  signatureStack: {
    gap: 10,
  },

  // ── Unsigned card — matches HTML `.people-signature-card` ──────────────
  sigCard: {
    borderWidth: 1,
    borderColor: '#D7E5F8',
    backgroundColor: AdminColors.blue25,
    borderRadius: 10,
    flexDirection: isWeb ? 'row' : 'column',
    alignItems: isWeb ? 'center' : 'stretch',
    gap: 16,
    padding: 14,
  },

  // ── Left info column ──────────────────────────────────────────────────
  sigInfoCol: {
    justifyContent: 'center',
    gap: 3,
    flex: isWeb ? 0.85 : undefined,
  },
  sigRoleLabel: {
    fontFamily: FontFamily.bold,
    fontSize: 10,
    color: AdminColors.blue800,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
  },
  sigName: {
    fontFamily: FontFamily.bold,
    fontSize: isWeb ? 14 : 13,
    color: AdminColors.textPrimary,
  },
  sigInstruction: {
    fontFamily: FontFamily.regular,
    fontSize: 12,
    color: AdminColors.textSecondary,
  },

  // ── Right pad column — matches HTML `.people-signature-pad` ────────────
  sigPadCol: {
    flex: isWeb ? 1.15 : undefined,
    minWidth: 0,
  },

  // ── Dashed canvas border — matches HTML `.people-signature-pad canvas` ─
  canvasWrapper: {
    borderWidth: 1,
    borderColor: '#7FA8DD',
    borderStyle: 'dashed',
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: AdminColors.bgSurface,
    minHeight: isWeb ? 140 : 120,
  },

  // ── Buttons row under the pad ─────────────────────────────────────────
  padActions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 8,
    marginTop: 8,
  },
  padButton: {
    borderWidth: 1,
    borderColor: AdminColors.borderDefault,
    borderRadius: 20,
    paddingHorizontal: 14,
    paddingVertical: 6,
    backgroundColor: AdminColors.bgSurface,
  },
  padButtonPrimary: {
    borderColor: AdminColors.blue700,
    backgroundColor: AdminColors.blue700,
  },
  padButtonText: {
    fontFamily: FontFamily.medium,
    fontSize: 13,
    color: AdminColors.textPrimary,
  },
  padButtonTextPrimary: {
    color: AdminColors.textOnDark,
  },
  padButtonDisabled: {
    opacity: 0.45,
  },

  // ── Signed card — matches HTML `.people-signature-card.is-signed` ──────
  sigCardSigned: {
    borderWidth: 1,
    borderColor: '#BEEFC2',
    backgroundColor: '#EAF9EA',
    borderRadius: 10,
    flexDirection: 'row',
    alignItems: isWeb ? 'center' : 'flex-start',
    gap: 12,
    padding: 14,
  },
  sigCheckCircle: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: AdminColors.green600,
    alignItems: 'center',
    justifyContent: 'center',
  },
  sigSignedCopy: {
    flex: 1,
    gap: 3,
    minWidth: 0,
  },
  sigSignedLabel: {
    fontFamily: FontFamily.bold,
    fontSize: 10,
    color: AdminColors.blue800,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
  },
  sigSignedName: {
    fontFamily: FontFamily.bold,
    fontSize: isWeb ? 14 : 13,
    color: AdminColors.textPrimary,
  },
  sigSignedMeta: {
    fontFamily: FontFamily.regular,
    fontSize: 11,
    color: AdminColors.textSecondary,
  },
  uploadingRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  signedImage: {
    width: Math.min(320, 260),
    height: 70,
    resizeMode: 'contain',
  },
  replaceButton: {
    alignSelf: isWeb ? 'center' : 'flex-end',
    borderWidth: 1,
    borderColor: AdminColors.borderDefault,
    borderRadius: 20,
    paddingHorizontal: 12,
    paddingVertical: 6,
    backgroundColor: AdminColors.bgSurface,
  },
  replaceButtonText: {
    fontFamily: FontFamily.medium,
    fontSize: 12,
    color: AdminColors.textPrimary,
  },
});

export default styles;
